"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DeviceIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DeviceIcon, _React$PureComponent);

  function DeviceIcon() {
    _classCallCheck(this, DeviceIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(DeviceIcon).apply(this, arguments));
  }

  _createClass(DeviceIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'device-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M7.43328255,7.93037489 L6.68530924,9.16239831 C6.55831377,9.37140228 6.29532315,9.46840412 6.07133115,9.37040226 C5.34635701,9.05739631 4.65338174,8.58538734 4.03440382,7.9673756 C3.41342598,7.34736382 2.94144282,6.65235061 2.62745402,5.92533679 C2.53145745,5.70033252 2.62745402,5.43732752 2.83644657,5.31132512 L4.06640268,4.56531095 C4.62838263,4.22430447 4.90337282,3.55629177 4.74337853,2.91827965 L4.29639448,1.13624578 C4.12940043,0.46823309 3.53042181,0.000224196663 2.84144639,0.000224196663 L1.99847647,0.000224196663 C1.66348842,-0.00677593636 1.3305003,0.150227047 1.13750718,0.460232938 C-0.676428095,3.37628835 -0.322440725,7.25636209 2.2104689,9.78941022 C4.74537846,12.3224584 8.62524002,12.6764651 11.5421359,10.8624306 C11.8601246,10.6654269 12.0131191,10.3424207 11.9991196,9.99941421 L11.9991196,9.15439815 C11.9991196,8.46638508 11.5311363,7.86637368 10.8631602,7.6993705 L9.07922383,7.25336203 C8.44124659,7.09435901 7.77427039,7.36836421 7.43328255,7.93037489"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return DeviceIcon;
}(_react.default.PureComponent);

exports.default = DeviceIcon;
DeviceIcon.defaultProps = {
  color: 'inherit'
};
DeviceIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};